import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SeparatorControl } from '../../../form-models/form-control-base';

@Component({
  selector: 'hb-dynamic-separator',
  templateUrl: './dynamic-separator.component.html',
})
export class DynamicSeparatorComponent {
  @Input() control: SeparatorControl;
  @Input() formGroup: FormGroup;

  constructor() {}
}
